var QueuePoller = function(args) {
    this.initialize(args);
};

QueuePoller.prototype = {
    /**
     * Sets an interval to check user activity every 30 seconds and adds
     * an unload listener to remove the listener when the page is unloaded.
     *
     * @param args
     */
    initialize: function(args) {
        window.queuePoller = this;
        this.pollingTerminated = false;
        this.collections = [];
        this.lastEventTime = new Date();
        this.pollTime = args.pollTime;
        this.idleTimeCheckInSeconds = 600; // 10 minutes of inactivity
        this.interval = args.interval;

        this.lastEventTime = new Date();

        // Start monitoring user activity.
        jQuery(document).ready(function($) {
            // Watch for user activity on the page.
            $(document).bind('mousemove keyup mousewheel', window.queuePoller.keepAlive);
        });
    },

    /**
     * The purpose of this method is to register a Backbone collection that requires polling.
     *
     * The Collection must implement poll() and isPollingEnabled(). The purpose of the isPollingEnabled
     * is to remove a collection from polling in the case of errors like 403. Each Collection is responsible
     * for determining what errors make it ineligible for polling.
     *
     * @param collection - The collection that will be polled.
     */
    addCollection: function(collection) {
        if (typeof collection === 'undefined' || collection === null) {
            throw new Error('Collection is required.');
        }
        if (typeof collection.poll === 'undefined') {
            throw new Error('Collection must implement a poll method.');
        }
        if (typeof collection.isPollingEnabled === 'undefined') {
            throw new Error('Collection must implement isPollingEnabled method.');
        }
        this.collections.push(collection);
    },

    /**
     *  Polls all registered Collections if the user is still active.
     */
    poll: function() {
        // Make sure that the user is still active.
        var that = window.queuePoller;
        // Timeout just popped, so handle is no longer needed.
        that.pollingTimeoutHandle = null;
        var now = new Date();
        var idleSeconds = (now.getTime() - that.lastEventTime.getTime()) / 1000;
        if (idleSeconds > that.idleTimeCheckInSeconds) {
            that.lastEventTime = new Date();
            that.log('Idle time has elapsed');
            that.stopPolling();
        } else {
            that.log('Start poll operations.');
            that.removeInactiveCollections(); // Remove collections that marked themselves inactive last poll time.
            jQuery.each(that.collections, function(index, collection) {
                collection.poll();
            });

            // Tee up the next poll
            that.start();
        }
    },

    /**
     * The purpose of this method is to remove inactive collections.
     * Collections may mark themselves inactive due to previous AJAX errors.
     */
    removeInactiveCollections: function() {
        var temp = [];
        jQuery.each(this.collections, function(index, collection) {
            if (collection.isPollingEnabled()) {
                temp.push(collection);
            }
        });
        this.collections = temp;
    },

    /**
     * The purpose of this method is to set a timeout to fire polling after a given poll interval expires.
     */
    start: function() {
        var that = this;
        this.stopPolling();
        if (this.collections.length > 0) {
            this.pollingTimeoutHandle = window.setTimeout(that.poll, this.pollTime);
            this.log('Polling is teed up.');
        } else {
            this.log('No enabled collections available to poll.');
        }
    },

    /**
     * Convenience method to test whether a window timeout handle is defined.
     * @return true if the timeout handle is set.
     */
    isPollingStarted: function() {
        return typeof this.pollingTimeoutHandle !== 'undefined' && this.pollingTimeoutHandle !== null;
    },

    /**
     * The purpose of this method stop the window timeout and clear the timeout handle.
     */
    stopPolling: function() {
        if (this.isPollingStarted()) {
            window.clearTimeout(this.pollingTimeoutHandle);
            this.pollingTimeoutHandle = null;
            queuePoller.pollingTerminated = true;
            this.log('Polling is stopped.');
        }
    },

    /**
     * The purpose of this method is to record the time of the last user activity.
     */
    keepAlive: function() {
        var that = window.queuePoller;
        if (that != null) {
            that.lastEventTime = new Date();
            if (!that.pollingTerminated && !that.isPollingStarted() && that.collections.length > 0) {
                that.log('User activity detected. Restarting polling.');
                that.start();
            }
        }
    },

    log: function(text) {
        if (typeof console !== 'undefined' && typeof console.log !== 'undefined') {
            console.log(new Date().toString() + ' - ' + text);
        }
    }
};

export default QueuePoller;
